import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { axiosInstance } from "../../services/v2/axiosInstance";
import "./whatsapp.css";

/*
	"Mandar Acceso Al Portal" en la ficha del alumno (Esteban, 2026-10-21). Manda (o vuelve a mandar) la invitación al
	portal por WhatsApp desde el número de Caja, con la plantilla del plantel. Solo para quien puede editar Estudiantes
	(la ficha pasa allowedUpdate). Si no se puede (ya tiene contraseña, sin WhatsApp con lada, 3 en el día), el botón
	queda apagado y el motivo en oro. Antes de mandar, confirma a qué número va.
*/
interface Estado {
	puede: boolean
	motivo: string | null
	telefono: string | null
	invitacion: { enviada: string | null, abierta: boolean, usada: boolean, error: string | null } | null
	enviosHoy: number
}

export const BotonAccesoPortal: React.FC<{ campusId: number, studentId: number }> = ({ campusId, studentId }) => {
	const ruta = "/admin/campus/" + campusId + "/students/" + studentId + "/_accesoPortal"
	const [estado, setEstado] = useState<Estado | null>(null)
	const [confirmar, setConfirmar] = useState(false)
	const [ocupado, setOcupado] = useState(false)
	const [aviso, setAviso] = useState<{ texto: string, malo: boolean } | null>(null)

	useEffect(() => {
		let vivo = true
		axiosInstance.get(ruta).then((r) => { if (vivo) setEstado(r.data) }).catch(() => { if (vivo) setEstado(null) })
		return () => { vivo = false }
	}, [ruta])

	if (!estado) return null

	const mandar = async () => {
		setOcupado(true); setAviso(null)
		try {
			const r = await axiosInstance.put(ruta, {})
			setEstado(r.data)
			setAviso({ texto: r.data.message, malo: r.status === 202 })
		} catch (x: any) {
			setAviso({ texto: x?.response?.data?.message || "No se pudo mandar. Revisa tu conexión e intenta otra vez.", malo: true })
			if (x?.response?.data?.puede !== undefined) setEstado(x.response.data)
		} finally {
			setOcupado(false)
			setConfirmar(false)
		}
	}

	const inv = estado.invitacion
	const ultima = inv ? ["Última: " + (inv.enviada || "no salió"), inv.usada ? "ya entró" : inv.abierta ? "abierta" : inv.error ? inv.error.toLowerCase() : "vencida"].join(" · ") : null

	return (
		<div className="wa-acceso">
			<button type="button" className="wa-acceso-btn" disabled={!estado.puede || ocupado} onClick={() => setConfirmar(true)}>
				{ocupado ? "Mandando…" : inv && inv.abierta ? "Volver A Mandar Acceso" : "Mandar Acceso Al Portal"}
			</button>
			{!estado.puede && estado.motivo ? <div className="wa-acceso-oro">{estado.motivo}</div> : null}
			{ultima ? <div className="wa-acceso-tenue">{ultima}</div> : null}
			{aviso ? <div className={aviso.malo ? "wa-acceso-oro" : "wa-acceso-ok"} role="status">{aviso.texto}</div> : null}
			<Modal show={confirmar} onHide={() => !ocupado && setConfirmar(false)} centered>
				<Modal.Header closeButton><Modal.Title>Mandar Acceso Al Portal</Modal.Title></Modal.Header>
				<Modal.Body>
					Se le mandará por WhatsApp al <b>{estado.telefono}</b> un enlace para crear su contraseña y entrar a su portal.
					{inv && inv.abierta ? " El enlace anterior deja de servir." : ""}
				</Modal.Body>
				<Modal.Footer>
					<button type="button" className="btn btn-default" disabled={ocupado} onClick={() => setConfirmar(false)}>Cancelar</button>
					<button type="button" className="btn btnPurple rounded-pill" disabled={ocupado} onClick={mandar}>{ocupado ? "Mandando…" : "Mandar"}</button>
				</Modal.Footer>
			</Modal>
		</div>
	)
}

export default BotonAccesoPortal
